import {
  LOSS_LIMIT,
  MAXIMUM_CREDIT_LIMIT, REALITY_CHECK, SESSION_DELAYED_LIMIT, SESSION_LIMIT,
  WAGER_LIMIT,
} from '@ezugi/constants';

/* We keep ukgc notifications separate
in order to not test for regression
 */
export const notificationTypes = [
  SESSION_DELAYED_LIMIT,
  MAXIMUM_CREDIT_LIMIT,
];

export const ukgcNotifications = [ REALITY_CHECK, SESSION_LIMIT, WAGER_LIMIT, LOSS_LIMIT ];
